if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

     //Hover Menu
    let currentMenuItem = $("#privary-navigation a.active").parent().index();
    $(".slideJS:eq(" + currentMenuItem + ")", ".figureSet").addClass("active");
    $("#privary-navigation > .privary-navigation__item > a").hover(function () {
        let hoverItem = $(this).parent().index();
        $(".slideJS").removeClass("active");
        $(".slideJS:eq(" + hoverItem + ")", ".figureSet").addClass("active");
    });



    $('.sym-slides').slick({
        accessibility: false
    });

    $('.fancybox').fancybox();

    $('.steps__step:not(.past)').click(function(e){
        e.preventDefault();
    });
   

    const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();

    //view more cta for dining form 

    $('.view-more-cta').nextAll().addClass('hidden siblings');

    const formViewMore = document.querySelector('.view-more-cta');

    if(formViewMore) {
        const siblings = document.querySelectorAll('.siblings');
        formViewMore.addEventListener('click', function() {
            siblings.forEach((element) => {
                element.classList.remove('hidden');
            });
            this.classList.add('hidden');
        });
    };

})();
